import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCalcPrices, selectCalcUsedVolumeWeight } from "./calcSlice";
import { Button } from "@mui/material";

import style from '../../sass/components/calc/calc-result.module.scss'
import { selectUser } from "../user/userSlice";
import { pushAlert } from "../alerts/alertSlice";
import { openCreatePopupWithChangingData } from "../shipments/shipmentsSlice";
import { setPathToShipments } from "../path/pathSlice";
import { validateUser } from "../../validators/validateUser";
import { useTranslation } from "react-i18next";
import { isB2BPackage, isC2CPackage, isStandardPackage } from "../../helpers/packageTypesHelper/packageTypesHelper";

const Result = ({ showContactPage, state }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const prices = useSelector(selectCalcPrices);
  const usedVolumeWeight = useSelector(selectCalcUsedVolumeWeight);
  const user = useSelector(selectUser)

  const [deliveryType, setDeliveryType] = useState("office-door");

  const customSetDeliveryType = (type) => {
    if (deliveryType === type) {
      return
    } else {
      setDeliveryType(type);
    }
  };


  const handleLeaveRequestButtonClick = () => {
    showContactPage();
  };


  const handleCreateShipmentButtonClick = () => {
    const errors = validateUser(user);
    if (errors && errors.length > 0) {
      dispatch(pushAlert({
        type: "warning",
        message: t("calculator.result.errors.user_data_not_filled"),
        delay: 2000,
      }));
      return;
    }

    if (user["user-type"] === "individual" && isB2BPackage(state["package-type"])) {
      dispatch(pushAlert({
        type: "warning",
        message: t("calculator.result.errors.individual_and_B2B"),
        delay: 2000,
      }))
      return
    }

    if (user["user-type"] === "legal" && isStandardPackage(state["package-type"])) {
      dispatch(pushAlert({
        type: "warning",
        message: t("calculator.result.errors.juridical_and_standard"),
        delay: 2000,
      }))
      return
    }

    if (user["user-type"] === "legal" && isC2CPackage(state["package-type"])) {
      dispatch(pushAlert({
        type: "warning",
        message: t("calculator.result.errors.juridical_and_c2c"),
        delay: 2000,
      }))
      return
    }

    let delType = ""
    if (deliveryType === "door-door" || deliveryType === "door-office") {
      delType = "courier"
    } else {
      delType = "visit office"
    }

    dispatch(setPathToShipments())
    dispatch(openCreatePopupWithChangingData(
      {
        senderCityCode: state["sender-city"],
        deliveryType: delType,
        packageType: state["package-type"],
        receiverGeolocation: {
          city: state["receiver-city"] ?? "",
          area: state["receiver-area"] ?? "",
          district: state["receiver-district"] ?? "",
          country: state["receiver-country"] ?? "",
        }

      }
    ))
  }

  if (!prices) return <></>

  return (
    <div>

      <div className="flex flex-col gap-2 mb-6">
        <div
          className={`
						${style.priceBlock} 
						${deliveryType === "office-door" ? style.selected : ""}
					`}
          onClick={() => customSetDeliveryType("office-door")}
        >
          <div className={`${style.content}`}>
            {t("calculator.result.office")} - {t("calculator.result.door")}
            <span className="font-semibold">
              ({prices["office-door"]}€)
            </span>
          </div>
        </div>
        <div
          className={`
						${style.priceBlock} 
						${deliveryType === "office-office" ? style.selected : ""}
					`}
          onClick={() => customSetDeliveryType("office-office")}
        >
          <div className={`${style.content}`}>
            {t("calculator.result.office")} - {t("calculator.result.office")}
            <span className="font-semibold">
              ({prices["office-office"]}€)
            </span>
          </div>
        </div>
        <div
          className={`
						${style.priceBlock} 
						${deliveryType === "door-door" ? style.selected : ""}
					`}
          onClick={() => customSetDeliveryType("door-door")}
        >
          <div className={`${style.content}`}>
            {t("calculator.result.door")} - {t("calculator.result.door")}
            <span className="font-semibold">
              ({prices["door-door"]}€)
            </span>
          </div>
        </div>
        <div
          className={`
						${style.priceBlock} 
						${deliveryType === "door-office" ? style.selected : ""}
					`}
          onClick={() => customSetDeliveryType("door-office")}
        >
          <div className={`${style.content}`}>
            {t("calculator.result.door")} - {t("calculator.result.office")}
            <span className="font-semibold">
              ({prices["door-office"]}€)
            </span>
          </div>
        </div>

        {usedVolumeWeight && (
          <div className="text-center text-basic text-red-700">
            {t("calculator.result.used_volume_weight")}
          </div>
        )}
      </div>

      <div className="flex gap-4">
        <Button
          variant="contained"
          disabled={true}
          sx={{
            color: "white",
            bgcolor: "#059669",
            fontSize: "0.7rem",
            padding: "0.5rem 1rem",
            width: "90%",
            ":hover": {
              bgcolor: "#047857",
            },
          }}
          onClick={handleLeaveRequestButtonClick}
        >
          {t("calculator.result.leave_request_button")}
        </Button>
        <Button
          className="col-span-5"
          variant="contained"
          sx={{
            color: "white",
            bgcolor: "#059669",
            fontSize: "0.7rem",
            padding: "0.5rem 1rem",
            width: "90%",
            ":hover": {
              bgcolor: "#047857",
            },
          }}
          onClick={handleCreateShipmentButtonClick}
        >{t("calculator.result.create_shipment_button")}</Button>
      </div>
    </div>
  );
};

export default Result;
